import { embedMessageTypes } from '@/constants/embed'

export const EMBED_MODE_KEY = 'dx_embed_mode'

export function markEmbedMode(): void {
  sessionStorage.setItem(EMBED_MODE_KEY, '1')
}

/**
 * A sessionToken in the URL has to be remembered before the IdP redirect,
 * because /callback no longer has that query param and the client is created
 * again on that load.
 */
export function rememberSessionTokenFromUrl(): void {
  const sessionToken = new URLSearchParams(window.location.search).get('sessionToken')
  if (sessionToken) {
    markEmbedMode()
  }
}

export function isEmbedSession(): boolean {
  const framed = window.self !== window.top
  const flagged = sessionStorage.getItem(EMBED_MODE_KEY) === '1'
  return framed || flagged
}

let sessionRequested = false

export function requestEmbedSession(message?: string): void {
  if (sessionRequested) {
    return
  }
  sessionRequested = true

  if (!window.top || window.top === window.self) {
    return
  }

  window.top.postMessage(
    {
      type: embedMessageTypes.EMBED_SESSION_REQUIRED,
      message: message ?? 'A new session token is required',
    },
    '*',
  )
}
